<template>
  <div
    class="tab-pane fade"
    :class="{ 'show active': isActive }"
    id="nav-gifting"
    role="tabpanel"
    aria-labelledby="nav-gifting-tab"
  >
    <div class="gifting">
      <div class="container">
        <div class="gifting-card">
          <div class="gifting-subtabs" role="tablist">
            <a
              v-for="tab in tabs"
              :key="tab.id"
              class="gifting-subtab"
              :class="{ active: activeTab === tab.id }"
              role="tab"
              :aria-selected="activeTab === tab.id ? 'true' : 'false'"
              href="#"
              @click.prevent="activeTab = tab.id"
            >
              <img
                :src="activeTab === tab.id ? tab.iconActive : tab.iconIdle"
                :alt="tab.title"
              />
              <span>
                <strong>{{ tab.title }}</strong>
                <small>{{ tab.subtitle }}</small>
              </span>
            </a>
          </div>

          <keep-alive v-if="opened">
            <GiftingGems v-if="activeTab === 'gems'" />
            <AnonymousGifting v-else />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GiftingGems from "./GiftingGems.vue";
import AnonymousGifting from "./AnonymousGifting.vue";
import { hasCheckoutReturn } from "@/utils/gifting";

export default {
  name: "Gifting",
  components: {
    GiftingGems,
    AnonymousGifting,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: "gems",
      opened: false,
      tabs: [
        {
          id: "gems",
          title: "Wallet",
          subtitle: "Manage your gems and balance",
          iconActive: "/assets/gifting/tab-gems-active.svg",
          iconIdle: "/assets/gifting/tab-gems-idle.svg",
        },
        {
          id: "anonymous",
          title: "Anonymous Feature",
          subtitle: "Send gifts without revealing your identity",
          iconActive: "/assets/gifting/tab-anonymous-active.svg",
          iconIdle: "/assets/gifting/tab-anonymous-idle.svg",
        },
      ],
    };
  },
  watch: {
    isActive: {
      immediate: true,
      handler(active) {
        if (active) this.opened = true;
      },
    },
  },
  created() {
    if (hasCheckoutReturn()) this.activeTab = "anonymous";
  },
};
</script>

<style scoped>
.gifting {
  --gift-gold: #fcb913;
  --gift-ink: #11151a;
  --gift-muted: #6b7280;
  --gift-disabled-bg: #e4e9f2;
  --gift-disabled-ink: #8a94ad;
  --gift-gradient: linear-gradient(
    90deg,
    #fdd34d 0%,
    var(--gift-gold) 55%,
    #f0980e 100%
  );

  background-color: #f2f2f2;
  padding: 32px 0 48px;
}

.gifting-card {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(17, 21, 26, 0.06);
  padding: 30px 34px 40px;
}

.gifting-subtabs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 30px;
}

.gifting-subtab {
  align-items: center;
  border-bottom: 2px solid #e8e8e8;
  color: inherit;
  display: flex;
  gap: 14px;
  padding: 6px 4px 18px;
  text-decoration: none;
}

.gifting-subtab.active {
  border-bottom-color: var(--gift-gold);
}

.gifting-subtab img {
  flex: 0 0 auto;
  height: 44px;
  width: 44px;
}

.gifting-subtab strong {
  color: var(--gift-ink);
  display: block;
  font-size: 16px;
  font-weight: 700;
}

.gifting-subtab small {
  color: var(--gift-muted);
  font-size: 14px;
}

@media (max-width: 767px) {
  .gifting-card {
    padding: 22px 18px 30px;
  }

  .gifting-subtabs {
    grid-template-columns: 1fr;
  }

  .gifting-subtab {
    padding-bottom: 14px;
  }
}
</style>
